import { Card, Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import headerImg from "../Assets/images/Group 112.png"
import ProgramHighlights from '../Components/programHighlights/ProgramHighlights'
import duration from "../Assets/images/duration.png";
import format from "../Assets/images/format.png";
import level from "../Assets/images/levels.png";
import certification from "../Assets/images/certification.png";
import WhatYouGetSection from '../Components/whatYouGetSection/WhatYouGetSection'
import whatYouGetImg from "../Assets/images/Frame 244.png";
import WhoThisProgramIsFor from '../Components/WhoThisProgramIsFor/WhoThisProgramIsFor'
import img1 from "../Assets/images/14.png"
import img2 from "../Assets/images/15.png"
import img3 from "../Assets/images/16.png"
import img4 from "../Assets/images/17.png"
import img5 from "../Assets/images/18.png"
import img7 from "../Assets/images/arSpecialization4.png"
import img28 from "../Assets/images/11.png";

import arSpecialization1 from "../Assets/images/ar-sp1.png"
import arSpecialization2 from "../Assets/images/ar-sp2.png"
import arSpecialization3 from "../Assets/images/ar-sp3.png"
import arSpecialization4 from "../Assets/images/ar-sp4.png"
import arSpecialization5 from "../Assets/images/arSpecialization5.png"
import { useState } from 'react';
import { Modal } from 'antd';
import RegistrationPopup from '../Components/registrationPopUp/RegistrationPopup';
import i18n from '../Translation/i18n';

const ArabicSpecialized = () => {

    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const items = [
        {
            title: t("linguistic_tools_title"),
            text: t("linguistic_tools_text"),
            bg: "#f7e8b5",
            img: arSpecialization1,
        },
        {
            title: t("real_life_scenarios_title"),
            text: t("real_life_scenarios_text"),
            bg: "#E7E7E9",
            img: arSpecialization2,
        },
        {
            title: t("fluency_title"),
            text: t("fluency_text"),
            bg: "#f7e8b5",
            img: arSpecialization3,
        },
        {
            title: t("specialized_units_title"),
            text: t("specialized_units_text"),
            bg: "#E7E7E9",
            img: arSpecialization4,
        },
    ];


    const cardsData = [
        { title: t("duration"), details: t("arabic_specialized_cardData.duration_details"), img: duration },
        { title: t("format"), details: t("arabic_specialized_cardData.format_details"), img: format },
        { title: t("level"), details: t("arabic_specialized_cardData.level_details"), img: level },
        { title: t("certification"), details: t("arabic_specialized_cardData.certification_details"), img: certification },
    ];

    const whatYouGetData = [
        { description: t("arabic_specialized_whatYouGet.item1") },
        { description: t("arabic_specialized_whatYouGet.item2") },
        { description: t("arabic_specialized_whatYouGet.item3") },
        { description: t("arabic_specialized_whatYouGet.item4") },
        { description: t("arabic_specialized_whatYouGet.item5") },
    ]

    const whatProgramFor = [
        { img: img1, title: t("healthcare_professionals"), desc: t("healthcare_professionals_desc") },
        { img: img2, title: t("doctors_nurses"), desc: t("doctors_nurses_desc") },
        { img: img3, title: t("medical_students"), desc: t("medical_students_desc") },
        { img: img5, title: t("languageSeekers"), desc: t("languageSeekers_desc") },
        { img: img28, title: t("travelars"), desc: t("parents_desc") },

        { img: img4, title: t("ngos_workers"), desc: t("ngos_workers_desc") },
        { img: img5, title: t("professionals"), desc: t("pro_desc") },
        { img: img3, title: t("specialized"), desc: t("specialized_desc") },

    ];
    return (
        <div className='ar-specialization'>
            <section className='arabicLife-sec'>
                <div className='first-section position-relative'>
                    <Row className='justify-content-start flex-column gx-0'>
                        <Col md={12} className='content-box'>
                            <Container>
                                {/* <img src={img2} alt='' className='my-4' /> */}
                                <h2 className='mb-3' style={{ marginTop: "150px" }}> {t("specialized_arabic")}</h2>
                                <h3>({t("medical_edition")})</h3>
                                <h5 className='mb-4'>
                                    {t("professional_arabic_description")}
                                </h5>

                            </Container>
                        </Col>

                    </Row>
                    <Row className='justify-content-start flex-column '>
                        <Col md={12} className='green-div'>
                            <div className='ap-second-section d-flex justify-content-start px-5 align-items-center '>
                                <Container>   <button className='btn fw-bold' onClick={() => setIsModalOpen(true)}>{t("start_now")}</button></Container>
                            </div>


                        </Col>

                    </Row>
                    <img src={headerImg} alt='' className='ar-life-logo' />
                </div>
            </section>

            <section>
                <Container>
                    <ProgramHighlights cardsData={cardsData} color='#C6B0D54D' />
                    <WhatYouGetSection data={whatYouGetData} img={whatYouGetImg} />
                </Container>
            </section>

            <section className='my-5'>
                <WhoThisProgramIsFor data={whatProgramFor} />
            </section>

            <section>
                <Container>

                    <div className='ar-third-section mb-5'>
                        <Row>
                            <Col lg={6} md={12}>
                                <div className="d-flex justify-content-center flex-column  w-100 h-100">
                                    <h6 className="green-title">
                                        {t("master_arabic_title")}
                                    </h6>
                                    <p dangerouslySetInnerHTML={{ __html: t("masterArabicParagraph") }} />


                                </div>
                            </Col>
                            <Col lg={6} md={12}>
                                <img src={img7} alt='' className='bookImage' />
                            </Col>
                        </Row>
                    </div>

                </Container>
            </section>

            <section className='structured-level'>
                <h1 className='text-center pt-5 fw-bold'>{t("structure_levels")}</h1>
                <Container className={`timeline-container py-5 ${i18n.resolvedLanguage === "ar" ? "rtl-timeline" : "ltr-timeline"}`}>
                    {items.map((item, index) => {
                        const isLeft = index % 2 === 0;
                        const isLast = index === items.length - 1;

                        return (
                            <Row key={index} className="timeline-row position-relative mb-5">
                                {!isLast && i18n.resolvedLanguage !== "ar" && (
                                    <div className={`connector-shape ${isLeft ? "left" : "right"}`}></div>
                                )}
                                {!isLast && i18n.resolvedLanguage === "ar" && (
                                    <div className={`connector-shape ${isLeft ? "right" : "left"}`}></div>
                                )}

                                {isLeft ? (
                                    <>
                                        <Col md={9} className="timeline-col-left position-relative">
                                            <Card
                                                className="timeline-card border-0 py-2"
                                                style={{ backgroundColor: item.bg, zIndex: "999" }}

                                            >
                                                <Card.Body>
                                                    <div className='d-flex gap-3 align-items-center'>
                                                        <img src={item.img} alt="" style={{ width: "145px", height: "130px" }} />
                                                        <div>
                                                            <Card.Title className='fw-bold'>{item.title}</Card.Title>
                                                            <Card.Text>{item.text}</Card.Text>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                        <Col md={3}></Col>
                                    </>
                                ) : (
                                    <>
                                        <Col md={3}></Col>
                                        <Col md={9} className="timeline-col-right position-relative">
                                            <Card
                                                className="timeline-card border-0   py-2"
                                                style={{ backgroundColor: item.bg, zIndex: "999" }}
                                            >
                                                <Card.Body>
                                                    <div className='d-flex gap-3 align-items-center'>
                                                        <img src={item.img} alt="" style={{ width: "145px", height: "130px" }} />
                                                        <div>
                                                            <Card.Title className='fw-bold'>{item.title}</Card.Title>
                                                            <Card.Text>{item.text}</Card.Text>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </>
                                )}
                            </Row>
                        );
                    })}
                </Container>
            </section>


            <Modal
                open={isModalOpen}
                footer={null}
                destroyOnClose
                onCancel={() => setIsModalOpen(false)}
                width={"80vw"} // close handler
            >
                <RegistrationPopup setIsModalOpen={setIsModalOpen} />
            </Modal>
        </div>


    );




}

export default ArabicSpecialized
